var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.delayOptions,"label":_vm.$t('delayBetweenAttempts'),"outlined":""},on:{"change":_vm.change},model:{value:(_vm.voiceDelay),callback:function ($$v) {_vm.voiceDelay=$$v},expression:"voiceDelay"}})
}
var staticRenderFns = []

export { render, staticRenderFns }